import { render, staticRenderFns } from "./FormButtons.vue?vue&type=template&id=1104fd29"
import script from "./FormButtons.vue?vue&type=script&lang=js"
export * from "./FormButtons.vue?vue&type=script&lang=js"
import style0 from "./FormButtons.vue?vue&type=style&index=0&id=1104fd29&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports